import { useEffect, useRef } from "react";
import Lenis from "lenis";
import RepairHeader from "../components/repair/RepairHeader";
import FabricacionHero from "../components/fabrication/FabricacionHero";
import RepairMarquee from "../components/repair/RepairMarquee";
import FabricacionCapabilities from "../components/fabrication/FabricacionCapabilities";
import FabricacionProcess from "../components/fabrication/FabricacionProcess";
import RepairQuoteForm from "../components/repair/RepairQuoteForm";
import RepairFooter from "../components/repair/RepairFooter";
import WhatsAppFab from "../components/WhatsAppFab";

const WA_FAB =
  "https://wa.me/524424319100?text=" +
  encodeURIComponent(
    "Hola, me interesa cotizar la fabricación de una guarda telescópica o fuelle con plano o muestra"
  );

const MARQUEE_ITEMS = [
  "Fabricación a medida",
  "Acero inoxidable",
  "Geometría OEM",
  "Bajo plano o muestra",
  "Corte y doblez CNC",
  "Levantamiento en planta",
];

const OG_IMAGE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/px4uzuxf_01%20%20%20%20CNC%20PROTECTION.png";

const SEO = {
  title: "Fabricación de Guardas Telescópicas CNC a Medida | Guarda Flex Querétaro",
  description:
    "Fabricación a medida de guardas telescópicas y fuelles para CNC en Querétaro: diseño bajo plano o muestra física, acero inoxidable y geometría original OEM. Cotiza con fotos o plano.",
};

export default function FabricacionGuardas() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl?.getAttribute("content");
    document.title = SEO.title;
    descEl?.setAttribute("content", SEO.description);

    const ogTags = [
      ["og:title", SEO.title],
      ["og:description", SEO.description],
      ["og:type", "website"],
      ["og:url", window.location.href],
      ["og:image", OG_IMAGE],
    ];
    const prevOg = {};
    ogTags.forEach(([property, content]) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
      }
      prevOg[property] = el.getAttribute("content");
      el.setAttribute("content", content);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.href.split("#")[0]);

    const root = document.documentElement;
    const prevScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
      root.style.scrollBehavior = prevScrollBehavior;
      document.title = prevTitle;
      if (descEl && prevDesc) descEl.setAttribute("content", prevDesc);
      Object.entries(prevOg).forEach(([property, prev]) => {
        const el = document.querySelector(`meta[property="${property}"]`);
        if (el && prev) el.setAttribute("content", prev);
      });
    };
  }, []);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="fabrication-page" className="bg-[#061226] text-white min-h-screen">
      <RepairHeader
        onNavigate={scrollToId}
        tagline="Fabricación a medida · Querétaro"
        ctaLabel="Cotizar fabricación"
        waUrl={WA_FAB}
      />
      <main>
        <FabricacionHero onNavigate={scrollToId} />
        <RepairMarquee items={MARQUEE_ITEMS} />
        <FabricacionCapabilities />
        <FabricacionProcess />
        <RepairQuoteForm variant="fabricacion" />
      </main>
      <RepairFooter />
      <WhatsAppFab />
    </div>
  );
}
